import _Button from "antd/es/button";
var _excluded = ["size", "loading", "icon", "className", "children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["type", "children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["loading", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cs from 'classnames';
import './index.less';

var InternalButton = function InternalButton(props) {
  var size = props.size,
      loading = props.loading,
      icon = props.icon,
      className = props.className,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var iconWarp;

  if (icon) {
    var _type;

    iconWarp = /*#__PURE__*/React.createElement("span", {
      className: cs('anticon', (icon === null || icon === void 0 ? void 0 : (_type = icon.type) === null || _type === void 0 ? void 0 : _type.displayName) === 'SLSymbolIcon' && 'sl-btn-symbol-icon')
    }, icon);
  }

  var slClassName = '';

  if ((!props.type || props.type === 'primary') && props.ghost && !props.danger) {
    slClassName = 'sl-btn-secondary';
  }

  if (!children && icon) {
    slClassName = slClassName + "sl-btn-only-icon-".concat(size);
  }

  return /*#__PURE__*/React.createElement(_Button, _extends({
    size: size,
    loading: loading,
    disabled: !!loading,
    icon: iconWarp,
    className: cs(className, slClassName, 'sl-btn')
  }, rest), children);
};

var SLButton = InternalButton;
SLButton.__ANT_BUTTON = true;
/**
 * ### 主按钮
 * ~~~js
 * import { SLPrimaryButton } from '@yy/sl-admin-components'
 * ~~~
 */

var InternalPrimaryButton = function InternalPrimaryButton(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(SLButton, _extends({}, rest, {
    type: "primary"
  }), children);
};

var InternalSecondaryButton = function InternalSecondaryButton(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/React.createElement(SLButton, _extends({}, rest, {
    ghost: true
  }), children);
};

var InternalTextButton = function InternalTextButton(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded4);

  return /*#__PURE__*/React.createElement(SLButton, _extends({
    type: type
  }, rest), children);
};

/**
 * ### 危险按钮
 * ~~~js
 * import { SLDangerButton } from '@yy/sl-admin-components'
 * ~~~
 */
var InternalDangerButton = function InternalDangerButton(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded5);

  return /*#__PURE__*/React.createElement(SLButton, _extends({}, rest, {
    type: "primary",
    danger: true
  }), children);
};
/**
 * ### 虚框按钮
 * ~~~js
 * import { SLDashedButton } from '@yy/sl-admin-components'
 * ~~~
 */


var InternalDashedButton = function InternalDashedButton(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded6);

  return /*#__PURE__*/React.createElement(SLButton, _extends({}, rest, {
    type: "dashed"
  }), children);
};

/**
 * ### icon按钮
 * ~~~js
 * import { SLIconButton } from '@yy/sl-admin-components'
 * ~~~
 */
var InternalIconButton = function InternalIconButton(props) {
  var loading = props.loading,
      _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      rest = _objectWithoutProperties(props, _excluded7);

  return /*#__PURE__*/React.createElement(SLButton, _extends({
    size: size,
    loading: loading,
    disabled: !!loading
  }, rest));
};

var SLPrimaryButton = InternalPrimaryButton;
var SLSecondaryButton = InternalSecondaryButton;
var SLTextButton = InternalTextButton;
var SLDangerButton = InternalDangerButton;
var SLDashedButton = InternalDashedButton;
var SLIconButton = InternalIconButton;
SLPrimaryButton.__ANT_BUTTON = true;
SLSecondaryButton.__ANT_BUTTON = true;
SLTextButton.__ANT_BUTTON = true;
SLDangerButton.__ANT_BUTTON = true;
SLDashedButton.__ANT_BUTTON = true;
SLIconButton.__ANT_BUTTON = true;
export { SLButton, SLPrimaryButton, SLSecondaryButton, SLTextButton, SLDangerButton, SLDashedButton, SLIconButton };